import { useBanner, bannerGroupsInlineStyleTitle, bannerGroupsInlineStyleDescription } from "../../..";
const BannerGroupSectionTitle = _ref => {
  let {
    title,
    children
  } = _ref;
  const banner = useBanner();
  return h("div", bannerGroupsInlineStyleTitle(banner), title, children && h("div", bannerGroupsInlineStyleDescription(banner), children));
};
export { BannerGroupSectionTitle };